<div class="effective-policy-settings">
  <app-popup-top-line></app-popup-top-line>
  <div class="effective-policy-settings-header">
    <div class="title">
      {{ 'policyPage.config.generalSettingsContent.effectivePolicySettingsTitle' | labelsProvider }}
      <div class="description">
        {{ getEffectivePolicySettingsDataName() | beautifyDisplayString }}
      </div>
    </div>
    <img class="close-button" src="assets/images/common/cancel.svg" (click)="onClose()" />
  </div>
  <div class="effective-policy-settings-body">
    <div class="effective-policy-settings-tables">
      <div *ngFor="let categoryToRule of effectivePolicySettingsData" class="category-section">
        <div class="effective-policy-settings-table">
          <div class="effective-policy-settings-table-header">
            <div class="effective-policy-settings-table-header-text">
              OWASP:
              {{ categoryToRule.owaspCodeName | beautifyDisplayString }}
              -
              {{ categoryToRule.category | beautifyDisplayString }}
            </div>
          </div>
          <div class="effective-policy-settings-table-body">
            <app-table
              [tableColumns]="EffectivePolicySettingsColumns"
              [tableRows]="getEffectivePolicySettingsRulesByCAtegory(categoryToRule.category)"
              [isScrollable]="true"
            >
            </app-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
